import { render, staticRenderFns } from "./ReCaptcha.vue?vue&type=template&id=ee6025a8"
import script from "./ReCaptcha.vue?vue&type=script&lang=js"
export * from "./ReCaptcha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee6025a8')) {
      api.createRecord('ee6025a8', component.options)
    } else {
      api.reload('ee6025a8', component.options)
    }
    module.hot.accept("./ReCaptcha.vue?vue&type=template&id=ee6025a8", function () {
      api.rerender('ee6025a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/ReCaptcha.vue"
export default component.exports